import intlTelInput from 'intl-tel-input';

const form = document.querySelector('#contactForm');

window.addEventListener('DOMContentLoaded', () => {
  if (form) {
    selectsHandle();
    countryCodeHandle();
    filesInputHandle();
  }
  validateInputs();

});

form?.addEventListener('submit', e => {
  e.preventDefault();
  e.stopPropagation();

  if (form.classList.contains('form--sending')) {
    return false;
  }

  form.classList.add('form--sending');

  const submit = form.querySelector('button[type=submit]');
  submit.blur();

  const inputs = form.querySelectorAll('input,textarea');
  const contactData = new FormData(form);

  Object.values(inputs).map(item => {
    const input_name = item.getAttribute('name');
    const input_value = item.value;

    if (input_name === 'telephone') {
      contactData.append(input_name, '+' + item.dataset.dialCode + ' ' + input_value.replace(/^0*/, ''));
    }
    else if (input_name === 'subject') {
      contactData.append(input_name, document.querySelector(`select#select_subject option[value="${input_value}"]`).innerText);
    }
    else {
      contactData.append(input_name, input_value);
    }
  });

  const errorInputs = document.querySelectorAll('.input--error');

  if (Object.values(errorInputs).length > 0) {
    errorInputs[0].focus();
    errorInputs[0].scrollIntoView();

    e.target.classList.remove('form--sending');
    return;
  }

  fetch('/wp-json/contact/v1/send', {
    method: 'post',
    body: contactData,
  }).then(async resp => {

    if (resp.status === 200) {
      const inputToFlush = form.querySelectorAll(
        'input:not(#lead_source, #retURL, #oid, #Form_Source__c, #utmsource__c, #fileDownload, #articleTitle),textarea,select');

      Object.values(inputToFlush).map(input => {
        input.value = '';
        input.classList.remove('edited');
      });

      window.scrollTo(0, 0);
      e.target.classList.remove('form--sending');
      e.target.classList.add('form--sent');
    }
    else {
      window.scrollTo(0, 0);
      e.target.classList.remove('form--sending');
      e.target.classList.add('form--error');
    }

    form.querySelector('input#pardot_extra_field').value = 'sent';
  });
});

//Disable enter for messages
const textArea = document.querySelectorAll('textarea');
Object.values(textArea).map(el =>
  el.addEventListener('keydown', e => {
    if (e.keyCode === 13 && !e.shiftKey) {
      e.preventDefault();
      return false;
    }
  }),
);

Object.values(document.querySelectorAll('form input, form select, form textarea')).map(item => {
  const events = ['blur', 'keyup'];

  events.map(event => {
    item.addEventListener(event, () => {
      item.classList.toggle('edited', item.value !== '');
    });
  });
});

// Check input with patterns
const validateInputs = () => {
  const inputs = document.querySelectorAll('input[data-pattern],input[type=file]');

  Object.values(inputs).map(input => {
    const pattern = input.dataset.pattern;
    const regexp = new RegExp(pattern, 'g');

    const error_message = document.createElement('SPAN');
    error_message.classList.add('error--message');
    error_message.innerText = input.dataset.error;

    input.addEventListener('blur', () => {
      if (input.type !== 'file') {
        if (input.value !== '') {
          if (!input.value.match(regexp)) {
            input.classList.add('input--error');
            input.closest('div').appendChild(error_message);
          }
        }
        else {
          input.classList.remove('input--error');
          error_message.remove();
        }
      }
    });

    input.addEventListener('blur', () => {
      let isValid, isEmpty;
      let error;
      if (input.type !== 'file') {
        if (input.value !== '') {
          if (input.classList.contains('iti__tel-input')) {
            input.setAttribute('aria-invalid', true);
            isValid = window.iti.isValidNumber();
            error = 'Le numéro de téléphone n\'est pas valide.';
          }
          else {
            input.setAttribute('aria-invalid', true);
            isValid = (input.value !== '' && input.value.match(regexp)?.length > 0);
            error = 'L\'adresse email n\'est pas valide.';
          }
        }
        else {
          input.setAttribute('aria-invalid', true);
          isEmpty = input.getAttribute('required');
          error = 'Le champ est obligatoire.';
        }

        error_message.innerText = error;

        if (!isValid || isEmpty) {
          input.classList.toggle('input--error', !isValid);
          error_message.remove();
          input.closest('div[class*="--wrapper"]').appendChild(error_message);

        }
        else {
          input.classList.remove('input--error');
          error_message.remove();
        }
      }

    });

    input.addEventListener('keyup', () => {
      if (input.type !== 'file') {
        if (input.value.match(regexp) || input.value === '') {
          input.classList.remove('input--error');
          error_message.remove();
        }
      }
    });

    if (input.type === 'file') {
      const max_size = 1000000;
      input.addEventListener('change', (e) => {
        const files = Array.from(e.target.files);
        const approvedFiles = new Array;
        const unapprovedFiles = new Array;

        [...files].map((file, index) => {
          if (file.size <= max_size) {
            approvedFiles.push(file);
          }
          else {
            console.log(index);
            const file_error = document.querySelectorAll('.file--recap p')[index];
            file_error.classList.add('text--red');
            unapprovedFiles.push(file);
          }
        });

        if (unapprovedFiles.length) {
          input.classList.add('input--error');
          input.closest('div').appendChild(error_message);
        }
        else {
          input.classList.remove('input--error');
          error_message.remove();
        }
      });
    }

  });

  Object.values(document.querySelectorAll('form input, form select, form textarea')).map(item => {
    const events = ['blur'];

    events.map(event => {
      item.addEventListener(event, () => {
        item.classList.toggle('edited', item.value !== '');
      });
    });
  });
};

const countryCodeHandle = () => {
  const input = document.querySelector('#telephone');
  window.iti = intlTelInput(input, {
    loadUtils: () => import('intl-tel-input/build/js/utils'),
    initialCountry: input.dataset.defaultCountry || 'fr',
    strictMode: true,
    customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {
      const telephone = document.querySelector('input#telephone');
      telephone.dataset.dialCode = selectedCountryData.dialCode;
      return selectedCountryPlaceholder;
    },
    //utilsScript: "/intl-tel-input/js/utils.js?1733052783337" // just for formatting/placeholders etc
  });
};

const selectsHandle = () => {
  const recipient = document.querySelector('#recipient');
  const subjects = document.querySelector('#select_subject');
  const offer = document.querySelector('#select_offer');

  if (subjects) {
    subjects.addEventListener('change', e => {
      [...subjects.selectedOptions].map(option => {
        recipient.value = option.dataset.recipient;

        offer.closest('.select--wrapper').style.display = option.value === 'offer' ? 'flex' : 'none';
        offer.required = option.value === 'offer';
        offer.value = '';
      });
    });
  }
};

const filesInputHandle = () => {
  const inputs = document.querySelectorAll('input[type=file]');

  [...inputs].map(input => {
    const recap = input.closest('div').querySelector('.file--recap');

    input.addEventListener('change', () => {
      const files = [];
      [...input.files].map(file => files.push(`<p>${file.name}</p>`));
      recap.innerHTML = files.join('');
    });
  });
};
